import $ from 'jquery';

const setHtmlAccessibility = function () {
    /*
        set attribute value to html tag
     */
    $('html').attr('lang', 'FR');

}

export {setHtmlAccessibility};


// WEBPACK FOOTER //
// ./src/js/cms/commons/setHtmlAccessibility.js